import styled from '@emotion/styled';
import InPlaceText from 'components/form/in_place_text';
import { LeagueLevelStore } from '@seedlang/stores';
import autobind from 'autobind-decorator';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { Link } from 'react-router';

const Wrapper = styled.div`
`;

@observer
class LeagueLevelsIndex extends React.Component {

  componentDidMount() {
    this.getLeagueLevels();
  }

  @autobind getLeagueLevels() {
    LeagueLevelStore.getIndex();
  }

  @computed get leagueLevels() {
    return LeagueLevelStore.indexData;
  }

  render() {
    return (
      <Wrapper>
        <table className='table-wrapper admin-table'>
          <thead>
            <tr>
              <th width='40' />
              <th width='40'>Position</th>
              <th>Name</th>
              <th width='100px'>Promotions</th>
              <th width='100px'>Demotions</th>
              <th width='200px'># Active Leagues</th>
              <th width='200px'># Active Users</th>
            </tr>
          </thead>
          <tbody>
            {
              this.leagueLevels.map(item => {
                return (
                  <tr
                    key={`${item.id}-${item.name}`}
                  >
                    <td>
                      <Link to={{name: 'builder.league_levels.edit', params: {leagueLevelId: item.id}}}>
                        <i className='fa fa-chevron-right fa-block' />
                      </Link>
                    </td>
                    <td>
                      <InPlaceText
                        type='number'
                        defaultValue={item.position}
                        model='league_levels'
                        field='position'
                        id={item.id}
                      />
                    </td>
                    <td>
                      <InPlaceText
                        defaultValue={item.name}
                        model='league_levels'
                        field='name'
                        id={item.id}
                      />
                    </td>
                    <td>
                      <InPlaceText
                        type='number'
                        defaultValue={item.promotionCount}
                        model='league_levels'
                        field='promotionCount'
                        id={item.id}
                      />
                    </td>
                    <td>
                      <InPlaceText
                        type='number'
                        defaultValue={item.demotionCount}
                        model='league_levels'
                        field='demotionCount'
                        id={item.id}
                      />
                    </td>
                    <td>
                      {item.activeLeaguesCount}
                    </td>
                    <td>
                      {item.activeUsersCount}
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </Wrapper>
    );
  }
}

export default LeagueLevelsIndex;
